import React from 'react';
import ImagingScheduleList from './imagingScheduleList';
import ScheduleDetails from './scheduleDetails';
import PlatesToImage from './platesToImage';
import InspectionsToScore from './inspectionsToScore';
import {
  ImagingSchedulesDTO,
  ImagingSchedulesDeletedDataDTO,
  PlateInspectionsToScoreDTO,
  PlatesToImageDTO,
} from 'business/models/Models';
import { ScheduleRowInfo } from './types';
import { RMModalProps } from 'components/modal/RMModal';

interface ImagingScheduleProps {
  imagingSchedulesDto: ImagingSchedulesDTO[];
  setImagingScheduleDto: React.Dispatch<React.SetStateAction<any[]>>;
  setDeletedData: React.Dispatch<React.SetStateAction<ImagingSchedulesDeletedDataDTO>>;
  scheduleErrors?: ScheduleRowInfo;
  platesToImage: PlatesToImageDTO[];
  plateInspectionsToScore: PlateInspectionsToScoreDTO[];
  setPlatesToImage: React.Dispatch<React.SetStateAction<PlatesToImageDTO[]>>;
  setPlateInspectionsToScore: React.Dispatch<
    React.SetStateAction<PlateInspectionsToScoreDTO[]>
  >;
  setModal?: React.Dispatch<React.SetStateAction<RMModalProps>>;
}

function ImagingScheduling(props: ImagingScheduleProps) {
  const {
    imagingSchedulesDto,
    setImagingScheduleDto,
    setDeletedData,
    scheduleErrors,
    platesToImage,
    plateInspectionsToScore,
    setPlatesToImage,
    setPlateInspectionsToScore,
    setModal,
  } = props;
  return (
    <div id="imagingscheduling-wrapper" className="h-[91vh]">
      <div
        id="imagingscheduling-schedule-container"
        className="flex flex-row w-full h-1/2"
      >
        <div id="imagingscheduling-schedule-list" className="w-[30%] border">
          <ImagingScheduleList
            imagingSchedulesDto={imagingSchedulesDto}
            setImagingScheduleDto={setImagingScheduleDto}
            setDeletedData={setDeletedData}
            scheduleErrors={scheduleErrors}
            setModal={setModal}
          />
        </div>
        <div id="imagingscheduling-schedule-details" className="w-[70%] border">
          <ScheduleDetails
            imagingSchedules={imagingSchedulesDto}
            setImagingScheduleDto={setImagingScheduleDto}
            setDeletedData={setDeletedData}
            scheduleErrors={scheduleErrors}
            setModal={setModal}
          />
        </div>
      </div>
      <div id="imagingscheduling-plates-container" className="flex flex-row w-full h-1/2">
        <div id="imagingscheduling-plates-toimage" className="w-1/2 border">
          <PlatesToImage
            platesToImage={platesToImage}
            setPlatesToImage={setPlatesToImage}
            setDeletedData={setDeletedData}
          />
        </div>
        <div id="imagingscheduling-plates-toscore" className="w-1/2 border">
          <InspectionsToScore
            plateInspectionsToScore={plateInspectionsToScore}
            setPlateInspectionsToScore={setPlateInspectionsToScore}
            setDeletedData={setDeletedData}
          />
        </div>
      </div>
    </div>
  );
}

export default ImagingScheduling;
